<template>
    <div class="w-full flex bg-gray-100">
        <div class="modals">
            <Modal v-show="this.show_message_modal" :display="this.show_message_modal" :error="this.error"
                :success="this.success" :modal_message="'test'" :question="this.warning" @positiveClick="submit"
                :positiveButton="this.success ? 'OK' : this.error ? null : 'YES'" @negativeClick="handleNegativeClick()"
                :negativeButton="this.error ? 'OK' : this.success ? null : 'NO'" z_value="z-50"
                :default_width="'max-w-lg'" id="vote_modal">
                <div
                    class="w-full p-5 pt-2 flex flex-col text-gray-500 text-lg justify-center text-center items-center">
                    {{ this.modal_message }}
                </div>
            </Modal>
            <Modal v-show="this.show_info_modal" :display="this.show_info_modal" :note="this.info"
                @positiveClick="show_info_modal = false" :positiveButton="'OK'" :default_width="'max-w-lg'"
                id="vote_modal">
                <div
                    class="w-full p-5 pt-2 flex flex-col text-gray-500 text-lg justify-center text-center items-center">
                    {{ this.modal_message }}
                </div>
            </Modal>
            <Modal v-show="show_new_pin" v-bind:display="show_new_pin" z_value="z-40" closable id='vote_modal'
                :default_width="'max-w-lg'">
                <div class="pt-6 w-full"></div>
                <!-- STEP 1: Input PIN -->
                <div v-if="!confirmUpdateMode">
                    <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Update PIN</h2>
                    <p class="mb-2 text-gray-600 text-base text-left">Your new Personal Identification Number (PIN) must
                        be exactly 6 digits and must not contain letters or
                        special characters.</p>

                    <div class="w-full flex flex-row justify-center my-4">
                        <v-otp-input :is-disabled="false" ref="new_pin_input" input-classes="otp-input"
                            @on-change="changeUpdatePIN" @on-complete="proceedToConfirmUpdate"
                            :input-type="new_pin_type" inputmode="numeric" :num-inputs="6" v-model:value="update_pin"
                            :should-auto-focus="false" :should-focus-order="false" :key="otpInputKey" />
                        <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                            @click="togglePeekerUpdatePin(1)">
                            <Icons :source="getImgSrcNewPin()" :width="24" />
                        </div>
                    </div>

                    <div v-if="update_pin_error" class="w-full flex items-center justify-center text-center">
                        <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                            v-text="update_pin_error" />
                    </div>


                    <!-- <div class="flex w-full justify-end mt-6">
                        <Button rounded @click="proceedToConfirmUpdate" :disabled="!change_update_pin"
                            button_text="NEXT" class="w-full max-w-full" />
                    </div> -->
                </div>

                <!-- STEP 2: Confirm PIN -->
                <div v-else>
                    <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">Confirm PIN</h2>
                    <p class="mb-2 text-gray-600 text-left text-base">Please re-enter your Personal Identification
                        Number (PIN) to confirm.</p>

                    <div class="w-full flex flex-row justify-center my-4">
                        <v-otp-input :is-disabled="false" ref="confirm_new_pin_input" input-classes="otp-input"
                            :input-type="con_pin_type" inputmode="numeric" :num-inputs="6"
                            @on-change="changeUpdateConPIN" @on-complete="submitUpdatedPin"
                            v-model:value="confirm_update_pin" :should-auto-focus="true" :key="otpInputKey" />
                        <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                            @click="togglePeekerUpdatePin(2)">
                            <Icons :source="getImgSrcConPin()" :width="24" />
                        </div>
                    </div>

                    <div v-if="update_pin_error" class="w-full flex items-center justify-center text-center">
                        <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                            v-text="update_pin_error" />
                    </div>


                    <div class="flex flex-row w-full justify-end gap-3 mt-6">
                        <Button is_secondary rounded @click="goBackToUpdatePinInput" button_text="BACK" />
                        <!-- <Button theme="bg-theme-primary text-white" :disabled="!change_update_con_pin" rounded
                            @click="submitUpdatedPin" button_text="SUBMIT" /> -->
                    </div>
                </div>
            </Modal>
            <!-- show_otp_modal -->
            <Modal v-show="show_otp_modal" v-bind:display="show_otp_modal" :z_value="'z-40'" :closed="closedOtp"
                :default_width="'max-w-xl'" id='otp_modal' closable>
                <div class="pt-6">

                    <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">OTP Verification</h2>
                    <p class="mb-5 text-base text-left">Please enter the One-Time Password (OTP) we have sent to your
                        Email Address or
                        Mobile Number to verify.
                    </p>

                    <div class="pb-2 w-full justify-items-center font-bold uppercase text-left p-2">
                        <v-otp-input :is-disabled="false" ref="otp_input" input-classes="otp-input"
                            :conditionalClass="['1', '2', '3', '4', '5', '6']" separator=" " :input-type="'number'"
                            inputmode="numeric" :num-inputs="6" @on-complete="handleOnCompleteEmail"
                            @on-change="changeOTP" v-model:value="otp" :should-auto-focus="true"
                            :should-focus-order="true" :key="otpInputKey" />
                    </div>

                    <div class="flex flex-row gap-x-2 pt-3 w-full justify-center text-center text-gray-400 text-sm">
                        <p>Didn't receive a code? <span v-show="!show_resend_otp" class="font-semibold">Resend in {{
                            formattedTimer }}</span></p>
                        <LinkText emit_triggered='resendOtp' @resendOtp="resendOtp" class="text-theme-primary font-bold"
                            text="Resend" v-show="show_resend_otp" />
                    </div>

                    <!-- Error Message Display -->
                    <div v-show="otp_error_message"
                        class="w-full flex items-center justify-center text-center mt-4 rounded-full">
                        <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                            v-text="otp_error_message" />
                    </div>
                </div>
            </Modal>

            <!-- PIN Validation-->
            <Modal v-show="show_pin_modal" v-bind:display="show_pin_modal" z_value="z-40" closable id='pin_modal'
                :default_width="'max-w-lg'">
                <div class="pt-6">

                    <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">PIN Verification</h2>
                    <p class="mb-5 text-left text-base">Please enter your Personal Identification Number (PIN) to
                        proceed with the
                        deactivation of the account.</p>

                    <div class="w-full flex flex-row justify-center my-4">
                        <v-otp-input :is-disabled="false" ref="deact_pin" input-classes="otp-input"
                            :input-type="deact_pin_type" inputmode="numeric" :num-inputs="6"
                            v-model:value="deact_pin_value" :should-auto-focus="true" :key="otpInputKey"
                            @on-complete="validateDeactPIN" @on-change="changePIN" />
                        <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                            @click="togglePeekerUpdatePin(3)">
                            <Icons :source="getImgSrcDeactPin()" :width="24" />
                        </div>
                    </div>

                    <div v-if="pin_error_message" class="w-full flex items-center justify-center text-center mt-3">
                        <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                            v-text="pin_error_message" />
                    </div>

                </div>
            </Modal>

            <Loading v-show="loading" :loading="loading" class="z-50" />
        </div>
        <div class="w-full flex flex-col p-6 lg:p-10" v-if="!deactivated">
            <h1 class="text-theme-primary text-3xl font-semibold mb-5">Settings</h1>
            <div class="w-full grid grid-cols-1 lg:grid-cols-3 gap-y-6 lg:gap-10">
                <!-- Sidebar Menu (Larger Devices Only) -->
                <div class="hidden lg:block col-span-1 p-7 text-lg font-medium bg-white rounded-2xl mb-auto"
                    v-show="showSidebar">
                    <div v-for="(item, index) in menuItems" :key="index">
                        <div class="flex items-center justify-between cursor-pointer" @click="toggleSection(index)">
                            <div class="flex items-center gap-2 py-3">
                                <img :src="item.icon" alt="" class="w-5 h-5" />
                                {{ item.title }}
                            </div>
                            <img :src="item.open ? arrowUp : arrowDown" alt="Toggle" class="w-6 h-6" />
                        </div>
                        <transition name="dropdown">
                            <div v-show="item.open" class="pl-5 mt-2 text-base font-normal space-y-1">
                                <p v-for="(subItem, subIndex) in item.subItems" :key="subIndex"
                                    class="cursor-pointer px-4 py-2 rounded-full" @click="selectSubItem(subItem)"
                                    :class="{
                                        'bg-theme-primaryLight text-theme-primary font-medium': selectedSubItem === subItem
                                    }">
                                    {{ subItem }}
                                </p>
                            </div>
                        </transition>
                    </div>
                </div>


                <!-- Sidebar Menu (Smaller Devices Only) -->
                <div class="flex lg:hidden w-full justify-start items-start text-left" v-show="showSidebar">
                    <div
                        class="w-auto text-lg font-medium mb-auto flex flex-row justify-start gap-3 items-center mobile-sidebar-menu">
                        <div v-for="(item, index) in menuItems" :key="index"
                            class="relative flex flex-col items-center group ">
                            <!-- Individual floating icon button -->
                            <div class="cursor-pointer p-2 rounded-full bg-white shadow-md hover:bg-gray-100 transition"
                                @click="toggleMobileSection(index)" :class="{
                                    'bg-theme-primaryLight': item.subItems.some(sub => selectedSubItem === sub)
                                }">
                                <img :src="item.icon" alt="icon" class="w-6 h-6" />
                            </div>

                            <!-- Dropdown appears below the icon -->
                            <transition name="dropdown">
                                <div v-show="item.open"
                                    class="absolute top-full ml-24 mt-2 bg-white rounded-xl shadow-md px-4 py-2 z-40 space-y-2 min-w-max text-left justify-start items-start">
                                    <p v-for="(subItem, subIndex) in item.subItems" :key="subIndex"
                                        class="cursor-pointer text-sm py-1 rounded-full whitespace-nowrap text-left"
                                        @click="selectSubItem(subItem)" :class="{
                                            'text-theme-primary font-medium': selectedSubItem === subItem
                                        }">
                                        {{ subItem }}
                                    </p>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>




                <!-- Dynamic Content Area -->
                <div class="col-span-2 bg-white rounded-2xl p-5 mb-auto">
                    <div v-if="selectedSubItem === 'Edit Username'">
                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Edit Username</p>
                        <p class="w-full text-gray-500 text-sm">Your username must be at least six (6) characters and
                            must not contain spaces and special characters. </p>

                        <div class="w-full h-full flex flex-row mt-5">
                            <div class="text-md w-full flex flex-col space-y-2">
                                <div class="w-full flex xs:flex-col space-x-4 items-center justify-center">
                                    <TextBoxField @changed="changed" v-if="currentUsername" :initial="currentUsername"
                                        id="username" placeholder="" class="w-full" :max_length="23"
                                        @enter="updateUsernameTrigger" />
                                </div>

                                <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                    <input type="checkbox" id="username_agree" v-model="username_agree"
                                        class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                    <label for="username_agree" class="cursor-pointer select-none">
                                        I agree with the <span @click="OpenPrivacy"
                                            class="underline cursor-pointer">Data Privacy</span>
                                    </label>
                                </div>


                                <div class="flex w-full justify-end">

                                    <Button rounded @clicked="updateUsernameTrigger"
                                        :disabled="enableUsername || !username_agree" button_text="UPDATE"
                                        :theme="'text-white'" :loading="this.updatingUsername"
                                        class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs px-4 mb-3" />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Edit Password'">
                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Edit Password</p>
                        <p class="w-full text-gray-500 text-sm">
                            Your password must be at least eight (8) characters long and include a combination of
                            uppercase and lowercase letters, numbers, and special characters.

                        </p>

                        <div class="w-full h-full flex flex-col mt-5">
                            <form class="text-md w-full flex flex-col space-y-2">
                                <div class="w-full flex">
                                    <TextBoxField ref="oldPasswordField" id="old_password" peekable @changed="changed"
                                        :validateOnInput="true" type="Password" placeholder="Old Password"
                                        :max_length="23" @enter="updatePasswordTrigger" />
                                </div>
                                <div class="w-full flex flex-col">
                                    <TextBoxField ref="newPasswordField" id="new_password" strength peekable
                                        :validateOnInput="true" @score="checkScore" @changed="changed" :max_length="23"
                                        @enter="updatePasswordTrigger" type="Password" placeholder="New Password" />
                                </div>
                                <div class="w-full flex">
                                    <TextBoxField ref="conPasswordField" id="con_password" peekable @changed="changed"
                                        :validateOnInput="true" type="Password" @enter="updatePasswordTrigger"
                                        :max_length="23" placeholder="Confirm Password" :confirmWith="new_password" />
                                </div>
                            </form>

                            <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                <input type="checkbox" id="password_agree" v-model="password_agree"
                                    class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                <label for="password_agree" class="cursor-pointer select-none">
                                    I agree with the <span @click="OpenPrivacy" class="underline cursor-pointer">Data
                                        Privacy</span>
                                </label>
                            </div>

                            <div class="flex w-full justify-end">
                                <Button rounded @clicked="updatePasswordTrigger"
                                    :disabled="disablePassword || !password_agree"
                                    class="w-full mt-2 max-w-full lg:max-w-xs" button_text="UPDATE"
                                    :loading="this.updatingPassword" :theme="'text-white'" />
                            </div>
                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Edit Email Address'">
                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Edit Email Address</p>

                        <p class="w-full text-gray-500 text-sm">
                            Your email address must be in a valid format (e.g., name@example.com) and must not contain
                            spaces.
                        </p>

                        <div class="w-full h-full flex flex-row mt-5">
                            <!--Regular-->
                            <div class="text-md w-full flex flex-col space-y-1" v-if="currentEmail">

                                <div class="w-full flex xs:flex-col items-center space-x-4">
                                    <TextBoxField @changed="changed" @enter="updateEmailTrigger" :max_length="49"
                                        :initial="this.currentEmail" type="email" id="email" />

                                </div>

                                <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                    <input type="checkbox" id="email_agree" v-model="email_agree"
                                        class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                    <label for="email_agree" class="cursor-pointer select-none">
                                        I agree with the <span @click="OpenPrivacy"
                                            class="underline cursor-pointer">Data
                                            Privacy</span>
                                    </label>
                                </div>

                                <div class="flex w-full justify-end">
                                    <Button rounded @clicked="updateEmailTrigger"
                                        :disabled="!enableEmail || !email_agree" button_text="UPDATE"
                                        :loading="this.updatingEmail" class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs"
                                        :theme="'text-white'" />
                                </div>
                            </div>
                            <!--Express-->
                            <div class="w-full flex flex-col" v-if="!currentEmail">
                                <div class="w-full flex items-center justify-center text-center mb-4">
                                    <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium"
                                        v-text="'Please enroll your Email Address'" />
                                </div>

                                <div class="w-full flex xs:flex-col">
                                    <TextBoxField @changed="changed" @enter="updateEmailTrigger" :max_length="49"
                                        :initial="currentEmail" type="email" id="email" />
                                </div>

                                <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                    <input type="checkbox" id="email_agree" v-model="email_agree"
                                        class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                    <label for="email_agree" class="cursor-pointer select-none">
                                        I agree with the <span @click="OpenPrivacy"
                                            class="underline cursor-pointer">Data
                                            Privacy</span>
                                    </label>
                                </div>

                                <div class="flex w-full justify-end mt-2">
                                    <Button rounded @clicked="updateEmailTrigger"
                                        :disabled="!enableEmail || !email_agree" button_text="UPDATE"
                                        :loading="updatingEmail" class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs"
                                        :theme="'text-white'" />
                                </div>
                                <!-- <div class="w-full flex xs:flex-col" v-if="express">
                                    <Button rounded @clicked="verifyAccount" :disabled="verify" button_text="VERIFY"
                                        class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs mt-2" :theme="'text-white'" />
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Edit Mobile Number'">
                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Edit Mobile Number</p>

                        <p class="w-full text-gray-500 text-sm">
                            Your mobile number must contain exactly ten (10) digits and must not include spaces,
                            letters, or special characters.
                            <span class="italic text-gray-400">Read our <span
                                    class="underline cursor-pointer hover:text-theme-primary"
                                    @click="OpenPrivacy">Privacy Policy</span> to see how we handle your information.
                            </span>
                        </p>
                        <div class="w-full h-full flex flex-row mt-5">
                            <!-- Regular -->
                            <div class="text-md w-full flex flex-col space-y-1" v-if="currentMobile">
                                <div class="w-full flex xs:flex-col items-center space-x-4" v-if="currentMobile">
                                    <TextBoxField nospecialchar @changed="changed" @enter="updateMobileTrigger"
                                        :initial="currentMobile" type="mobile" id="mobile_number" :max_length="9" />
                                </div>

                                <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                    <input type="checkbox" id="mobile_agree" v-model="mobile_agree"
                                        class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                    <label for="mobile_agree" class="cursor-pointer select-none">
                                        I agree with the <span @click="OpenPrivacy"
                                            class="underline cursor-pointer">Data
                                            Privacy</span>
                                    </label>
                                </div>

                                <div class="flex w-full justify-end">
                                    <Button rounded @clicked="updateMobileTrigger"
                                        :disabled="!enableMobile || !mobile_agree" button_text="UPDATE"
                                        :loading="this.updatingMobile"
                                        class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs" :theme="'text-white'" />
                                </div>
                            </div>

                            <!-- Express -->
                            <div class="w-full flex flex-col" v-if="!currentMobile">
                                <div class="w-full flex items-center justify-center text-center mb-4">
                                    <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium"
                                        v-text="'Please enroll your mobile number'" />
                                </div>


                                <div class="w-full flex">
                                    <TextBoxField nospecialchar @changed="changed" @enter="updateMobileTrigger"
                                        :initial="currentMobile" type="mobile" id="mobile_number" :max_length="9"
                                        class="h-full" />
                                </div>

                                <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                    <input type="checkbox" id="mobile_agree" v-model="mobile_agree"
                                        class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                    <label for="mobile_agree" class="cursor-pointer select-none">
                                        I agree with the <span @click="OpenPrivacy"
                                            class="underline cursor-pointer">Data
                                            Privacy</span>
                                    </label>
                                </div>

                                <div class="flex w-full justify-end mt-2">
                                    <Button rounded @clicked="updateMobileTrigger"
                                        :disabled="!enableMobile || !mobile_agree" button_text="UPDATE"
                                        :loading="updatingMobile" class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs"
                                        :theme="'text-white'" />
                                </div>
                                <!-- <div class="w-full flex xs:flex-col">
                                    <Button rounded @clicked="verifyAccount" :disabled="verify" button_text="VERIFY"
                                        class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs mt-2" :theme="'text-white'"/>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Add Birthdate'">
                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Add Birthdate</p>
                        <p class="w-full text-gray-500 text-sm">
                            Your birthdate must be in a valid format (e.g., MM/DD/YYYY) and must not be a future date.
                            <span class="italic text-gray-400">Read our <span
                                    class="underline cursor-pointer hover:text-theme-primary"
                                    @click="OpenPrivacy">Privacy Policy</span> to see how we handle your information.
                            </span>
                        </p>
                        <div class="w-full h-full flex flex-col mt-5">
                            <div class="w-full flex xs:flex-col items-center space-x-4">
                                <TextBoxField @changed="changed" @enter="updateBirthdateTrigger" :max_length="49"
                                    type="date" id="date" />

                            </div>

                            <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                <input type="checkbox" id="bday_agree" v-model="bday_agree"
                                    class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                <label for="bday_agree" class="cursor-pointer select-none">
                                    I agree with the <span @click="OpenPrivacy" class="underline cursor-pointer">Data
                                        Privacy</span>
                                </label>
                            </div>


                            <div class="flex w-full justify-end mt-2">
                                <Button rounded @clicked="updateBirthdateTrigger" :disabled="!enableDate || !bday_agree"
                                    button_text="Add" class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs"
                                    :theme="'text-white'" />
                            </div>

                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Add TIN'">
                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Add Taxpayer Identification Number (TIN)</p>

                        <p class="w-full text-gray-500 text-sm">
                            Your TIN must be a 9-digit number (e.g., 123-456-789) without letters, special characters,
                            or spaces.
                            <span class="italic text-gray-400">Read our <span
                                    class="underline cursor-pointer hover:text-theme-primary"
                                    @click="OpenPrivacy">Privacy Policy</span> to see how we handle your information.
                            </span>
                        </p>


                        <div class="w-full h-full flex flex-row mt-5">
                            <TextBoxField :initial="currentTin" @changed="changed" @enter="updateTinTrigger" type="text"
                                id="tin" />
                        </div>

                        <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                            <input type="checkbox" id="tin_agree" v-model="tin_agree"
                                class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                            <label for="tin_agree" class="cursor-pointer select-none">
                                I agree with the <span @click="OpenPrivacy" class="underline cursor-pointer">Data
                                    Privacy</span>
                            </label>
                        </div>


                        <div class="flex w-full justify-end mt-2">
                            <Button rounded @clicked="updateTinTrigger" :disabled="!enableTIN || !tin_agree"
                                button_text="Add" class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs"
                                :theme="'text-white'" />
                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Deactivate'">
                        <div>
                            <div class="w-full" v-show="!deactivated">
                                <div class="">
                                    <p
                                        class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                                        Deactivate Account</p>
                                    <span
                                        v-text="'Deactivating your account will restrict access to your data and services. Please enter your password to proceed.'"
                                        class="w-full text-gray-400 text-sm" />
                                    <div class="w-full flex flex-row justify-center h-full mt-5">
                                        <div class="w-full h-full flex flex-col space-y-2">
                                            <div class="w-full">
                                                <TextBoxField ref="Pass" type="Password" id="deac" peekable
                                                    @changed="changed" @enter="deactivateAccountTrigger" required
                                                    placeholder="Password" :max_length="23" />
                                            </div>
                                            <div class="flex w-full justify-end">
                                                <Button theme="bg-red-500 text-white" rounded
                                                    @click="deactivateAccountTrigger" :disabled="enableDeact"
                                                    :button_text="'DEACTIVATE ACCOUNT'" is_error
                                                    class="w-full max-w-full lg:max-w-xs" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="w-full" v-show="deactivated">
                                <div class="flex flex-row justify-center h-full">
                                    <div class="w-full h-full flex flex-col space-y-2">

                                        <p
                                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                                            Reactivate Account</p>
                                        <span
                                            v-text="'Your account is currently deactivated. To restore access, please re-activate your account.'"
                                            class="w-full text-gray-400 text-sm" />
                                        <div class="flex pt-5">
                                            <Button theme="bg-theme-primary text-white" rounded
                                                @click="reactivateAccountTrigger" :button_text="'REACTIVATE ACCOUNT'"
                                                :loading="this.updatingPassword" class="max-w-full lg:max-w-xs" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="selectedSubItem === 'Edit PIN'">
                        <div v-show="!deactivated && !no_pin">
                            <p
                                class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                                Edit PIN</p>

                            <p class="w-full text-gray-500 text-sm">
                                To update your Personal Identification Number (PIN), please first enter your current PIN
                                to proceed.
                                <span class="italic text-gray-400">Read our <span
                                        class="underline cursor-pointer hover:text-theme-primary"
                                        @click="OpenPrivacy">Privacy Policy</span> to see how we handle your
                                    information.
                                </span>
                            </p>

                            <div v-show="$store.state.credentials.pso_enroll && $store.state.credentials.pin_update"
                                class="w-full flex items-center justify-center text-center my-4">
                                <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium"
                                    v-text="'Please change your Temporary Personal Identification Number (PIN)'" />
                            </div>

                            <div class="flex flex-row justify-center h-full mt-5">
                                <div class="w-full h-full flex flex-col space-y-2 justify-start">

                                    <div class="w-full flex flex-row justify-center">
                                        <div @keyup.enter="updatePinTrigger">
                                            <v-otp-input :is-disabled="false" ref="old_pin_input"
                                                input-classes="otp-input"
                                                :conditionalClass="['1', '2', '3', '4', '5', '6']" class="mb-5"
                                                @on-change="changeOldPIN" @on-complete="change_pin_btn = true"
                                                separator=" " :input-type="old_pin_type" inputmode="numeric"
                                                :num-inputs="6" v-model:value="old_pin" :should-auto-focus="true"
                                                :should-focus-order="true" :key="otpInputKey" />
                                        </div>
                                        <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                                            @click="togglePeeker">
                                            <Icons id="textbox_icon" v-bind:source="getImgSrc()" :width="24" />
                                        </div>
                                    </div>

                                    <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                        <input type="checkbox" id="pin_agree" v-model="pin_agree"
                                            class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                        <label for="pin_agree" class="cursor-pointer select-none">
                                            I agree with the <span @click="OpenPrivacy"
                                                class="underline cursor-pointer">Data Privacy</span>
                                        </label>
                                    </div>

                                    <div class="flex w-full justify-center">
                                        <Button rounded :disabled="!change_pin_btn || !pin_agree"
                                            @click="updatePinTrigger" :button_text="'CHANGE PIN'" :theme="'text-white'"
                                            class="w-full max-w-full lg:max-w-[26rem]" />
                                    </div>

                                    <!-- <div class="text-center py-4">
                                        <p>Forgot your PIN? <span class="text-theme-primary hover:underline font-semibold cursor-pointer">RESET</span></p>
                                    </div> -->

                                    <div v-show="error_pin_message"
                                        class="w-full flex items-center justify-center text-center mb-4">
                                        <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium"
                                            v-text="error_pin_message" />
                                    </div>

                                </div>
                            </div>
                        </div>


                        <!--Enroll PIN-->
                        <div v-show="no_pin">
                            <div v-if="!confirmMode" class="enroll-pin">
                                <p
                                    class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                                    Enroll PIN</p>
                                <span class="w-full text-gray-400 text-sm">
                                    Your Personal Identification Number (PIN) must be exactly six (6) digits and must
                                    not
                                    contain letters or special
                                    characters.
                                </span>
                                <div class="w-full flex flex-row justify-center my-4">
                                    <v-otp-input :is-disabled="false" ref="pin_input" input-classes="otp-input"
                                        :input-type="old_pin_type" inputmode="numeric" :num-inputs="6"
                                        @on-change="changeEnrollPIN" @on-complete="enable_next = true"
                                        v-model:value="enroll_pin" :should-auto-focus="true" :key="otpInputKey" />
                                    <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                                        @click="togglePeeker">
                                        <Icons id="textbox_icon" v-bind:source="getImgSrc()" :width="24" />
                                    </div>
                                </div>

                                <!-- Error Message Display -->
                                <div v-show="pin_error"
                                    class="w-full flex items-center justify-center text-center mt-4 rounded-full">
                                    <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium"
                                        v-text="pin_error" />
                                </div>

                                <div class="flex flex-row w-full justify-center items-center mt-5">
                                    <Button
                                        theme="bg-theme-primary text-white"
                                        rounded
                                        :disabled="!enable_next"
                                        @click="proceedToConfirm"
                                        :button_text="'NEXT'"
                                        class="w-full max-w-full lg:max-w-[26rem]"
                                    />

                                    <!-- <p @click="goBackToInitial" class="font-medium text-theme-primary underline cursor-pointer">Go Back</p> -->
                                </div>

                            </div>

                            <div v-else class="confirm-pin">
                                <p
                                    class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                                    Confirm PIN</p>
                                <span class="w-full text-gray-400 text-sm">Please re-enter your Personal Identification
                                    Number (PIN) to confirm.</span>
                                <div class="w-full flex flex-row justify-center my-4">
                                    <v-otp-input :is-disabled="false" ref="confirm_pin_input" input-classes="otp-input"
                                        :input-type="old_pin_type" @on-complete="enroll_con_btn = true" inputmode="numeric" :num-inputs="6"
                                        @on-change="changeEnrollConPIN"
                                        v-model:value="confirm_pin" :should-auto-focus="true" :key="otpInputKey" />
                                    <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                                        @click="togglePeeker">
                                        <Icons id="textbox_icon" v-bind:source="getImgSrc()" :width="24" />
                                    </div>
                                </div>

                                <div class="flex flex-row space-x-2 text-sm mt-4 pb-4 lg:pb-0 items-center text-gray-600">
                                    <input type="checkbox" id="pin_agree" v-model="pin_agree"
                                        class="cursor-pointer w-4 h-4 accent-[#016B00]" />
                                    <label for="pin_agree" class="cursor-pointer select-none">
                                        I agree with the <span @click="OpenPrivacy"
                                            class="underline cursor-pointer">Data Privacy</span>
                                    </label>
                                </div>

                                <!-- Error Message Display -->
                                <div v-show="pin_error"
                                    class="w-full flex items-center justify-center text-center my-4 rounded-full">
                                    <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium"
                                        v-text="pin_error" />
                                </div>


                                <div class="flex flex-row w-full justify-center items-center space-x-3 mt-5">
                                    <Button is_secondary rounded @click="goBackToInitial" :button_text="'Back'"
                                        class="w-full max-w-full lg:max-w-[26rem]" />
                                    <Button
                                        theme="bg-theme-primary text-white"
                                        rounded
                                        @click="enrollPin"
                                        :disabled="!enroll_con_btn || !pin_agree"
                                        :button_text="'SUBMIT'"
                                        class="w-full max-w-full lg:max-w-[26rem]"
                                    />

                                    <!-- <p @click="goBackToInitial" class="font-medium text-theme-primary underline cursor-pointer">Go Back</p> -->
                                </div>


                            </div>
                        </div>

                    </div>
                    <div v-else-if="selectedSubItem === 'Authentication'">

                        <p
                            class="w-fit px-3 py-1 text-gray-600 mb-2 font-medium text-lg border-l-8 border-theme-secondary">
                            Authentication
                        </p>

                        <!-- <p class="w-full text-gray-500 text-sm">
                                Protect your account by setting up additional authentication methods. 
                                <span class="italic text-gray-400">Read our <span class="underline cursor-pointer hover:text-theme-primary" @click="OpenPrivacy">Privacy Policy</span> to see how we handle your information.</span>
                            </p> -->

                        <div
                            class="w-full flex flex-col lg:flex-row border-2 border-gray-100 p-5 rounded-2xl mt-5 justify-between items-center gap-3 lg:gap-32">
                            <div class="flex flex-col space-y-1">
                                <p class="font-semibold text-gray-500">One-Time Password (OTP)</p>
                                <p class="text-gray-400">Add an extra layer of security with One-Time Password (OTP)
                                    sent via SMS or Email. This will be used to verify your identity during sign-in or
                                    sensitive actions.</p>
                            </div>

                            <div class="toggle">
                                <ToggleControl v-model="authValue" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <div class="w-full h-[60vh] lg:h-[85vh] flex items-center justify-center" v-if="deactivated">
            <div
                class="bg-white rounded-2xl shadow-sm flex flex-col justify-center items-center text-center p-8 w-full max-w-xl">
                <img src="https://resource.pafcpic.net/assets/papsi/papsi_logo.png" class="w-1/3 mb-5" />
                <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-center">Welcome back!</h2>
                <p class="mb-4">Before you can use the member portal, we want to make sure you want to re-activate your
                    account. Please confirm below and verify your account to proceed.</p>
                <div class="flex pt-5 w-full">
                    <Button theme="bg-theme-primary text-white" rounded @click="reactivateAccountTrigger"
                        :button_text="'RE-ACTIVATE ACCOUNT'" :loading="this.updatingPassword" class="" />
                </div>
            </div>
        </div>

    </div>

</template>
<script>
import { defineComponent } from 'vue';
import TextBoxField from '@/components/controls/TextBoxField.vue';
import Button from '@/components/controls/ButtonControl.vue';
import Loading from '@/components/controls/LoadingControl.vue';
import User from "@/services/User";
import OTP from "@/services/OTP";
import axios from 'axios'
import Modal from '@/components/controls/ModalControl.vue';
import LinkText from "@/components/controls/LinkText";
import VOtpInput from "vue3-otp-input";
import Icons from '@/components/controls/Icon.vue';
import ToggleControl from '@/components/controls/ToggleControl.vue';
export default defineComponent({
    components: {
        TextBoxField,
        Button,
        Loading,
        Modal,
        Icons,
        ToggleControl,
        LinkText,
        VOtpInput,
    },
    inject: ['setLoading'],
    data() {
        return {
            enable_next: false,
            username_agree: false,
            password_agree: false,
            email_agree: false,
            mobile_agree: false,
            tin_agree: false,
            bday_agree: false,
            pin_agree: false,
            showSidebar: true,
            password_changed: false,
            confirmUpdateMode: false,
            showUpdateUsername: true,
            showUpdateEmail: false,
            error_pin_message: '',
            update_pin_error: '',
            change_pin_btn: false,
            change_update_pin: false,
            change_update_con_pin: false,
            update_pin: '',
            pin: '',
            enroll_pin: '',
            enroll_btn: false,
            enroll_con_btn: false,
            confirmMode: false,
            deact_logout: false,
            show_info_modal: false,
            showUpdateMobile: false,
            enableMobile: false,
            enableEmail: false,
            day: '',
            month: '',
            year: '',
            authValue: 0,
            skipAuthWatcher: true,
            enableDate: false,
            enableTIN: false,
            confirm_pin: '',
            pin_error: '',
            show_pin_modal: false,
            showAccountInfoView: true,
            showPasswordUpdateView: false,
            showSecurityView: false,
            showDeactivateAccountView: false,
            showUpdateUsernameModal: false,
            showUpdateEmailModal: false,
            showUpdateMobileModal: false,
            showUpdatePasswordModal: false,
            showDeactivateAccountModal: false,
            showUpdateTin: false,
            show_new_pin: false,
            showSuccessModal: false,
            disablePassword: true,
            show_message_modal: false,
            showOtpModal: false,
            updatingUsername: false,
            updatingEmail: false,
            updatingMobile: false,
            disable_tin: false,
            updatingPassword: false,
            deactivatingAccount: false,
            deactivatedAccount: false,
            message: '',
            otpType: '',
            otp: '',
            otpInputKey: 0,
            new_pin: '',
            con_pin: '',
            updateType: '',
            errors_log: [],
            currentUsername: '',
            currentEmail: '',
            verify: true,
            visible: false,
            currentMobile: '',
            account_number: '',
            has_pin: '',
            show_resend_otp: false,
            timerCount: 0,
            timerEnabled: false,
            full_name: '',
            show_menu: false,
            email: '',
            number: '',
            new_pin_type: 'password',
            con_pin_type: 'password',
            visible_new_pin: false,
            visible_con_pin: false,
            visible_deact_pin: false,
            Astatus: '',
            deac: '',
            reac: '',
            tin: '',
            Mstatus: '',
            clearText: '',
            express: false,
            enableUsername: true,
            enableDeact: true,
            deactivated: false,
            serial: '',
            loading: false,
            disablenum: true,
            disableemail: true,
            disableuser: true,
            username: '',
            old_pin: '',
            info: false,
            currentTin: '',
            old_password: '',
            show_new_pin_pass: false,
            show_con_pin_pass: false,
            new_password: '',
            con_password: '',
            pin_error_message: '',
            otp_error_message: '',
            mobile_number: '',
            deactivate_payload: null,
            password_deact: '',
            error: false,
            success: false,
            warning: false,
            otp_pin: '',
            birthdate: '',
            deactivation_pin: '',
            deact_pin_value: '',
            otp_token: '',
            score: '',
            modal_message: '',
            old_pin_type: 'password',
            deact_pin_type: 'password',
            show_otp_modal: false,
            expired: false,
            otp_payload: null,
            error_pin: false,
            edit_payload: null,
            no_pin: false,
            arrowDown: require('@/assets/images/papsi_next.svg'),
            arrowUp: require('@/assets/images/papsi_down.svg'),
            selectedSubItem: 'Edit Username',
            menuItems: [
                {
                    title: "Account Information",
                    icon: require('@/assets/images/papsi_account.svg'),
                    open: true,
                    subItems: ["Edit Username", "Edit Password"]
                },
                {
                    title: "Contact Information",
                    icon: require('@/assets/images/papsi_contact.svg'),
                    open: false,
                    subItems: ["Edit Email Address", "Edit Mobile Number"]
                },
                {
                    title: "Member Information",
                    icon: require('@/assets/images/papsi_membership.svg'),
                    open: false,
                    subItems: ["Add Birthdate", "Add TIN"]
                },
                {
                    title: "Security",
                    icon: require('@/assets/images/papsi_security.svg'),
                    open: false,
                    subItems: ["Edit PIN", "Authentication", "Deactivate"]
                }
            ]
        }
    },
    computed: {
        formattedTimer() {
            const min = Math.floor(this.timerCount / 60);
            const sec = this.timerCount % 60;
            return `${min}:${sec.toString().padStart(2, '0')}`;
        },
    },
    mounted() {
        const that = this;
        const state = this.$store.state;

        that.currentUsername = state.credentials.username;
        that.currentEmail = state.credentials.email;
        that.currentMobile = state.credentials.mobile ? state.credentials.mobile.replace('+63', '') : '';
        that.has_pin = state.credentials.has_pin;
        that.currentTin = state.credentials.tin;
        that.birthdate = state.credentials.birthdate;
        that.deactivated = state.credentials.deactivated;
        that.express = state.credentials.express;
        that.skipAuthWatcher = true;
        that.authValue = state.credentials.config?.status ? 1 : 0;
        that.$nextTick(() => {
            that.skipAuthWatcher = false;
        });


        if (!state.credentials.username) {
            this.getUserInfo();
        } else {
            this.checkUserFlow();
        }

        if (window.innerWidth < 1024) {
            this.menuItems.forEach(item => item.open = false);
        } else {
            this.menuItems[0].open = true;
        }


    },
    methods: {
        hideSidebar() {
            const state = this.$store.state.credentials;
            return (
                !state.has_pin ||             // no PIN
                state.pin_update ||           // PIN is being updated
                !state.email ||               // email is empty/null
                !state.mobile                 // mobile is empty/null
            );
        },
        enable3FA() {
            let that = this;
            let store = that.$store;
            let state = store.state;
            let type = 2;
            let status = that.authValue;

            that.setLoading(true);
            User.setConfig(state.credentials.uuid, type, status).then(function () {
                if (!state.credentials.config) {
                    state.credentials.config = { type: null, status: null };
                }
                state.credentials.config.status = status;

                state.credentials.config.status = status === 1;
                that.setLoading(false);
            }).catch(function (error) {
                that.error = true;
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.setLoading(false);
            });
        },
        changeUpdatePIN() {
            this.change_update_pin = false;
            this.update_pin_error = '';
        },
        changeUpdateConPIN() {
            this.change_update_con_pin = false;
            this.update_pin_error = '';
        },
        toggleSection(index) {
            this.menuItems[index].open = !this.menuItems[index].open;
        },
        selectSubItem(subItem) {
            this.selectedSubItem = subItem;
            if (window.innerWidth < 1024) {
                this.menuItems.forEach(item => item.open = false);
                document.removeEventListener('click', this.handleOutsideClickMobile);
            }
        },
        toggleMobileSection(index) {
            // Toggle only the clicked section
            this.menuItems = this.menuItems.map((item, i) => ({
                ...item,
                open: i === index ? !item.open : false
            }));

            // If any menu is open, add outside click listener
            if (this.menuItems.some(item => item.open)) {
                document.addEventListener('click', this.handleOutsideClickMobile);
            }
        },
        handleOutsideClickMobile(event) {
            // Check if the click is outside the sidebar menu
            if (!event.target.closest('.mobile-sidebar-menu')) {
                this.menuItems.forEach(item => item.open = false);
                document.removeEventListener('click', this.handleOutsideClickMobile);
            }
        },
        checkScore(e) {
            this.score = e;
        },
        changeOTP() {
            this.otp_error_message = '';
        },
        changePIN() {
            this.pin_error_message = '';
        },
        changeOldPIN() {
            this.change_pin_btn = false;
            this.error_pin_message = '';
        },
        enrollPin() {
            let that = this;
            const cookie = that.$cookies;
            let store = that.$store;
            let state = store.state;
            let payload = {
                hash: cookie.get('user_session').hash,
                pin: that.enroll_pin,
            };
            let payload_new_pin = {
                hash: cookie.get('user_session').hash,
                value: that.enroll_pin,
            }
            if (this.enroll_pin !== this.confirm_pin) {
                this.pin_error = 'PINs do not match.';
                this.enroll_con_btn = false;
                this.confirm_pin = '';
                this.otpInputKey++;
                return;
            }

            this.pin_error = '';

            that.setLoading(true);
            User.testPin(payload).then(function () {
                User.updatePin(cookie.get('user').uuid, payload_new_pin).then(function () {
                    that.success = true;
                    that.updateType = 7;
                    that.warning = false;
                    that.info = false;
                    that.error = false;
                    that.setLoading(false);
                    that.show_message_modal = true;
                    that.modal_message = "Congratulations! You have successfully enrolled your PIN.";
                    that.showSidebar = true;

                    const state = that.$store.state;
                    const config = state.credentials.config;
                    state.credentials.has_pin = true;
                    state.credentials.enrolled_pin = true;
                    state.credentials.pin_update = false;

                    if (!config || !config.status) {
                        that.$cookies.set('validated', true);
                    }

                }).catch(function (error) {
                    that.success = false;
                    that.error = true;
                    that.note = false;
                    that.setLoading(false);
                    that.show_message_modal = true;
                    that.modal_message = error.response.data.message;
                    that.show_otp_modal = false;
                    that.otp = '';
                    that.otpInputKey++;
                });
            }).catch(function (error) {
                // that.$refs.new_pin_input.clearInput();
                // that.$refs.con_pin_input.clearInput();
                that.success = false;
                that.error = true;
                that.warning = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.otpInputKey++;
            });

            // console.log(that.enroll_pin);
        },
        OpenPrivacy() {
            this.$emit('OpenPrivacy');
        },
        verifyAccount() {
            let that = this;
            let store = that.$store;
            let state = store.state;
            that.setLoading(true);
            User.verifyACcount(state.credentials.uuid).then(function () {
                that.express = false;
                state.credentials.express = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = "Your account has been verified. Thank you.";
            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.otpInputKey++;
            });
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);
            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                that.skipAuthWatcher = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.gaUser = data.ga;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                that.username = state.credentials.username;
                that.currentUsername = state.credentials.username;
                that.currentEmail = state.credentials.email;
                that.currentMobile = state.credentials.mobile != null ? state.credentials.mobile.replace('+63', '') : '';
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                state.balances = data.balances;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.authValue = state.credentials.config?.status ? 1 : 0;
                that.skipAuthWatcher = false;

                if (state.credentials.birthdate) {
                    that.menuItems.forEach(item => {
                        if (item.title === "Member Information") {
                            item.subItems = item.subItems.filter(sub => sub !== "Add Birthdate");
                        }
                    });
                }

                if (state.credentials.tin) {
                    that.menuItems.forEach(item => {
                        if (item.title === "Member Information") {
                            item.subItems = item.subItems.filter(sub => sub !== "Add TIN");
                        }
                    });
                }

                if (state.credentials.tin && state.credentials.birthdate) {
                    that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                    that.otpInputKey++;
                }
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.otpInputKey++;
            });
        },
        checkUserFlow() {
            let that = this;
            const store = that.$store;
            let state = store.state;

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (!that.currentEmail || !that.currentMobile) {
                if (that.currentTin && that.birthdate) {
                    that.menuItems = that.menuItems.filter(item => item.title !== "Account Information");
                    that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");
                    that.menuItems = that.menuItems.filter(item => item.title !== "Security");
                    if (!that.currentEmail) {
                        that.selectedSubItem = 'Edit Email Address';

                        that.menuItems.forEach(item => {
                            item.open = item.subItems.includes('Edit Email Address');
                        });

                        that.menuItems.forEach(item => {
                            if (item.title === "Contact Information") {
                                item.subItems = item.subItems.filter(sub => sub !== "Edit Mobile Number");
                            }
                        });
                        that.showSidebar = false;
                    }
                    if (!that.currentMobile) {
                        that.selectedSubItem = 'Edit Mobile Number';

                        that.menuItems.forEach(item => {
                            item.open = item.subItems.includes('Edit Mobile Number');
                        });

                        that.menuItems.forEach(item => {
                            if (item.title === "Contact Information") {
                                item.subItems = item.subItems.filter(sub => sub !== "Edit Email Address");
                            }
                        });
                        that.showSidebar = false;
                    }
                    return;
                }

            }
            if (that.birthdate) {
                that.menuItems.forEach(item => {
                    if (item.title === "Member Information") {
                        item.subItems = item.subItems.filter(sub => sub !== "Add Birthdate");
                    }
                });
            }
            if (that.currentTin) {
                that.menuItems.forEach(item => {
                    if (item.title === "Member Information") {
                        item.subItems = item.subItems.filter(sub => sub !== "Add TIN");
                    }
                });
            }
            if (that.currentTin && that.birthdate) {
                that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");

            }
            if (!that.currentEmail) {
                that.selectedSubItem = 'Edit Email Address';

                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes('Edit Email Address');
                });
                that.showSidebar = false;
                return;
            }
            if (!that.currentMobile) {
                that.selectedSubItem = 'Edit Mobile Number';

                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes('Edit Mobile Number');
                });
                that.showSidebar = false;
                return;
            }
            if (!state.credentials.birthdate) {
                this.selectedSubItem = 'Add Birthdate';
                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes('Add Birthdate');
                });
            }
            if (!state.credentials.tin) {
                this.selectedSubItem = 'Add TIN';
                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes('Add TIN');
                });
            }
            if (state.credentials.pin_update) {
                that.show_info_modal = true;
                that.info = true;
                that.error = false;
                that.success = false;
                that.showSidebar = false;
                that.modal_message = "You are currently using a temporary PIN. For your security, please update your PIN to continue.";
                that.menuItems = that.menuItems.filter(item => item.title !== "Account Information");
                that.menuItems = that.menuItems.filter(item => item.title !== "Contact Information");
                that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");
                that.menuItems.forEach(item => {
                    if (item.title === "Security") {
                        item.subItems = item.subItems.filter(sub => sub !== "Authentication");
                        item.subItems = item.subItems.filter(sub => sub !== "Deactivate");
                    }
                });

                that.selectedSubItem = 'Edit PIN';
                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes('Edit PIN');
                });
                return;
            }
            if (!state.credentials.has_pin) {
                that.no_pin = true;
                that.show_info_modal = true;
                that.info = true;
                that.error = false;
                that.success = false;
                that.showSidebar = false;
                that.modal_message = "You currently don't have your Personal Identification Number (PIN). Enroll them to proceed.";
                that.menuItems = that.menuItems.filter(item => item.title !== "Account Information");
                that.menuItems = that.menuItems.filter(item => item.title !== "Contact Information");
                that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");
                that.menuItems.forEach(item => {
                    if (item.title === "Security") {
                        item.subItems = item.subItems.filter(sub => sub !== "Authentication");
                        item.subItems = item.subItems.filter(sub => sub !== "Deactivate");
                    }
                });

                that.selectedSubItem = 'Edit PIN';

                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes('Edit PIN');
                });
                return;
            } else {
                that.no_pin = false;
            }
        },
        deactivateAccountTrigger() {
            if (this.enableDeact) return;
            this.updateType = 5;
            this.otpType = '3';
            this.modal_message = "Are you sure you want to deactivate your account?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        closedOtp() {
            this.show_otp_modal = false;
        },
        updatePinTrigger() {
            if (!this.change_pin_btn) return;
            if (this.old_pin.length > 1) {
                this.updateType = 8;
                // this.otpType = '3';
                this.modal_message = "Are you sure you want to change your Personal Identification Number (PIN)?";
                this.warning = true;
                this.error = false;
                this.success = false;
                this.show_message_modal = true;
            }
        },
        updatePin() {
            let that = this;
            const cookie = that.$cookies;
            // console.log(that.new_pin,that.con_pin);
            if (that.new_pin && that.con_pin) {
                if (that.new_pin == that.con_pin) {
                    let pin_payload = {
                        hash: cookie.get('user_session').hash,
                        value: that.new_pin,
                        pin: that.old_pin
                    }
                    // User.updatePin();
                    that.setLoading(true);
                    that.error_pin = false;
                    User.updatePin(cookie.get('user').uuid, pin_payload).then(function () {
                        that.show_new_pin = false,
                            that.setLoading(false);
                        that.success = true;
                        that.warning = false;
                        that.error = false;
                        that.info = false;
                        that.modal_message = "Congratulations! You have successfully updated your PIN.";
                        that.change_pin_btn = false;
                        that.pin_agree = false;
                        that.old_pin = '';
                        // that.getUserInfo();
                        that.show_message_modal = true;
                        that.$store.state.credentials.pin_update = false;
                        that.showSidebar = true;
                    }).catch(function (error) {
                        if (error.response.status === 403) {
                            that.expired = true;
                            that.$store.state.logged = false;
                            that.setLoading(false);
                            that.error = true;
                            that.info = false;
                            that.warning = false;
                            that.success = false;
                            that.show_message_modal = true;
                            that.modal_message = "Your session has expired. Please log in again.";
                        }
                        that.error = true;
                        that.warning = false;
                        that.success = false;
                        that.info = false;
                        that.show_new_pin = false;
                        that.setLoading(false);
                        that.show_message_modal = true;
                        that.modal_message = error.response.data.message;
                        that.show_otp_modal = false;
                        that.otp = '';
                        that.otpInputKey++;
                    });
                } else {
                    that.error_pin = true;
                    that.pin_error_message = "PINs do not match.";
                }
            } else {
                that.pin_error_message = "Don't leave the PIN empty."
                that.error_pin = true;
            }
        },

        reactivateAccountTrigger() {
            let that = this;
            // const store = this.$store;
            // let state = store.state;

            // if(this.reac == state.credentials.account_no) {
            that.updateType = 7;
            that.otpType = '4';
            that.modal_message = "Are you sure you want to re-activate your account?";
            that.warning = true;
            that.info = false;
            that.error = false;
            that.success = false;
            that.show_message_modal = true;
            // }else{
            //     this.error = true;
            //     this.show_message_modal = true;
            //     this.modal_message = "Account number miss match";
            // }

        },
        submit() {
            let that = this;
            let store = that.$store;
            let state = store.state;
            const cookie = that.$cookies;
            if (!that.expired) {
                if (that.success) {
                    if (that.updateType == 5) {
                        cookie.remove('user');
                        cookie.remove('user_session');
                        that.$router.push('/');
                        return;
                    }
                    if (that.password_changed || that.deact_logout) {
                        state.credentials.hash = '';
                        state.logged = false;
                        that.expired = false;
                        that.$cookies.remove('user');
                        that.$cookies.remove('user_session');
                        that.$router.push('/');
                        return;
                    }
                    if (that.updateType == 7) {
                        that.$router.push('/dashboard');
                        return;
                    }
                    if (!that.$cookies.get('validated')) {
                        that.$router.push('/dashboard');
                        return;
                    }
                    that.show_message_modal = false;
                }
                else if (that.error) {
                    that.show_message_modal = false;
                }
                else {
                    if (that.updateType == 1) {
                        that.updateUsername();
                    }
                    if (that.updateType == 2) {
                        that.validateEmail();
                    }
                    if (that.updateType == 3) {
                        that.validateMobile();
                    }
                    if (that.updateType == 4) {
                        that.updatePassword();
                    }
                    if (that.updateType == 5) {
                        // that.show_pin_modal = true;
                        that.deactivateAccount();
                    }
                    if (that.updateType == 6) {
                        that.updateTin();
                    }
                    if (that.updateType == 7) {
                        that.reactivateRequest();
                    }
                    // console.log(that.updateType);
                    if (that.updateType == 8) {
                        that.validateOldPin();
                    }
                    if (that.updateType == 9) {
                        that.addBirthdate();
                    }
                }
            } else {
                if (that.expired) {
                    state.credentials.hash = '';
                    state.logged = false;
                    that.expired = false;
                    that.$cookies.remove('user');
                    that.$router.push('/')
                }
            }

        },
        reactivateRequest() {
            let that = this;

            const cookie = that.$cookies;
            that.setLoading(true);
            // console.log(cookie.get('user_session').hash);
            that.show_message_modal = false;
            User.reactivateRequest(cookie.get('user').uuid, cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                that.otp_payload = {
                    reactivation_key: data.hash,
                    pin: data.pin,
                    email: that.currentEmail,
                    type: '4',
                    mobile: '+63' + that.currentMobile
                };
                // that.$refs.otp_input.clearInput();
                that.timerEnabled = true;
                that.timerCount = 120;
                that.show_otp_modal = true;
                that.otp = '';
                that.otpInputKey++;
                that.show_pin_modal = true;
                that.setLoading(false);
            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.setLoading(false);
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
            });
        },
        addBirthdate() {
            const that = this;
            const cookie = that.$cookies;
            // const birthdate = `${that.year}-${that.month}-${that.day}`;
            var payload = {
                hash: cookie.get('user_session').hash,
                month: that.month,
                day: that.day,
                year: that.year
            };
            that.setLoading(true);
            that.show_message_modal = false;
            User.addBirthdate(that.$store.state.credentials.key, payload).then(function () {
                that.setLoading(false);
                that.success = true;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.modal_message = "Congratulations! You have successfully added your birthdate.";
                that.show_message_modal = true;
                that.bday_agree = false;
                that.showSidebar = true;
                that.birthdate = `${that.year}-${that.month}-${that.day}`;
                that.$store.state.credentials.birthdate = that.birthdate;
                const birthDateObj = new Date(that.birthdate);
                const today = new Date();
                let age = today.getFullYear() - birthDateObj.getFullYear();
                const monthDiff = today.getMonth() - birthDateObj.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
                    age--;
                }
                that.$store.state.credentials.age = age;

                that.menuItems.forEach(item => {
                    if (item.title === "Member Information") {
                        item.subItems = item.subItems.filter(sub => sub !== "Add Birthdate");
                    }
                });

                // Open "Edit Username" as active nav
                that.selectedSubItem = "Edit Username";
                // Optionally, open the Account Information section
                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes("Edit Username");
                });

                if (that.currentTin && that.birthdate) {
                    that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");
                }

            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                } else {
                    that.modal_message = error.response.data.message;

                }
                that.error = true;
                that.info = false;
                that.warning = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
            });
        },
        validateOldPin() {
            let that = this;

            const cookie = that.$cookies;
            let pin_payload = {
                hash: cookie.get('user_session').hash,
                pin: that.old_pin
            }
            that.setLoading(true);
            that.show_message_modal = false;
            that.show_new_pin = false;
            that.update_pin = '';
            that.confirm_update_pin = '';
            that.otpInputKey++;
            that.update_pin_error = '';
            that.confirmUpdateMode = false;
            that.change_update_pin = false;
            User.validateOldPin(cookie.get('user').uuid, pin_payload).then(function () {
                // let data = response.data.data;
                // console.log(data);

                that.otpInputKey++;
                that.show_new_pin = true;

                that.setLoading(false);
            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.error = true;
                that.warning = false;
                that.info = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.old_pin = '';
                that.change_pin_btn = false;
                that.otpInputKey++;
            });
        },
        validateDeactPIN() {
            let that = this;

            const cookie = that.$cookies;
            let pin_payload = {
                hash: cookie.get('user_session').hash,
                pin: that.deact_pin_value
            }
            that.setLoading(true);
            that.show_message_modal = false;
            User.validateOldPin(cookie.get('user').uuid, pin_payload).then(function () {
                // let data = response.data.data;
                // console.log(data);
                that.timerEnabled = true;
                that.timerCount = 120;
                that.show_pin_modal = false;
                that.show_otp_modal = true;
                that.otp = '';
                that.otpInputKey++;
                that.setLoading(false);
            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.setLoading(false);
                that.pin_error_message = error.response.data.message;
                that.otpInputKey++;
                that.deact_pin_value = '';
            });
        },
        logout() {
            this.loading = true;
        },
        validateEmail() {
            let that = this;
            const cookie = that.$cookies;
            that.setLoading(true);
            let payload = {
                hash: cookie.get('user_session').hash,
                value: that.email
            }
            that.setLoading(true);
            that.show_otp_modal = false;
            that.show_message_modal = false;
            User.validateEmail(cookie.get('user').uuid, payload).then(function (response) {
                let data = response.data.data;
                that.otp_payload = {
                    update_key: data.hash,
                    pin: data.pin,
                    email: that.email,
                    type: data.type
                };

                that.show_otp_modal = true;
                that.otp_error_message = '';
                that.otp = '';
                that.otpInputKey++;
                that.timerEnabled = true;
                that.timerCount = 120;
                that.show_resend_otp = false;
                that.setLoading(false);
            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.timerEnabled = true;
                that.timerCount = 120;
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
            });
        },
        validateMobile() {
            let that = this;
            const cookie = that.$cookies;
            that.setLoading(true);
            let payload = {
                hash: cookie.get('user_session').hash,
                value: '+63' + that.mobile_number
            }
            that.setLoading(true);
            that.show_message_modal = false;
            that.show_otp_modal = false;
            User.validateMobile(cookie.get('user').uuid, payload).then(function (response) {
                let data = response.data.data;
                that.otp_payload = {
                    update_key: data.hash,
                    pin: data.pin,
                    mobile: '+63' + that.mobile_number,
                    type: data.type
                };
                that.show_otp_modal = true;
                that.otp_error_message = '';
                that.otp = '';
                that.otpInputKey++;
                that.timerEnabled = true;
                that.timerCount = 120;
                that.show_resend_otp = false;
                that.setLoading(false);
            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.error = true;
                that.warning = false;
                that.info = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
            });
        },
        donelogout() {
            this.loading = false;
        },
        closed_modal() {
            this.show_message_modal = false;
        },
        reactivateAccount() {
            let that = this;
            const cookie = that.$cookies;
            that.setLoading(true);
            User.reactivate(cookie.get('user').uuid).then(function () {
                that.setLoading(false);
                that.success = true;
                that.warning = false;
                that.info = false;
                that.error = false;
                that.modal_message = "Congratulations! You have successfully reactivated your account.";
                that.getUserInfo();
                that.show_message_modal = true;
                that.showSidebar = true;
                that.timerEnabled = false;
                that.timerCount = 120;

            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
            });
        },
        updateUsernameTrigger() {
            if (this.enableUsername) return;
            this.updateType = 1;
            this.modal_message = "Are you sure you want to update your username?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updateEmailTrigger() {
            if (!this.enableEmail) return;
            this.otpType = '6';
            this.updateType = 2;
            this.modal_message = "Are you sure you want to update your email address?";
            this.show_message_modal = true;
            this.warning = true;
            this.error = false;
            this.success = false;
        },
        updateMobileTrigger() {
            if (!this.enableMobile) return;
            this.otpType = '7';
            this.updateType = 3;
            this.modal_message = "Are you sure you want to update your mobile number?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updateBirthdateTrigger() {
            if (!this.enableDate) return;
            this.updateType = 9;
            this.modal_message = "Are you sure you want to add your birthdate?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updateTinTrigger() {
            if (!this.enableTIN) return;
            this.updateType = 6;
            this.modal_message = "Are you sure you want to add your TIN?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        updatePasswordTrigger() {
            if (this.disablePassword) return;
            this.updateType = 4;
            this.modal_message = "Are you sure you want to update your password?";
            this.warning = true;
            this.error = false;
            this.success = false;
            this.show_message_modal = true;
        },
        showUpdateUsernameView() {
            if (this.showUpdateUsername == false) {
                this.showUpdateUsername = true;
                this.showUpdateEmail = false;
                this.showUpdateMobile = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showUpdateEmailView() {
            if (this.showUpdateEmail == false) {
                this.showUpdateEmail = true;
                this.showUpdateUsername = false;
                this.showUpdateMobile = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        updateUsername() {
            const that = this;
            const cookie = that.$cookies;
            var payload = {
                hash: cookie.get('user_session').hash,
                value: that.username,
            }
            that.setLoading(true);
            // that.currentUsername = '';
            that.show_message_modal = false;
            User.editUserName(cookie.get('user').uuid, payload).then(function () {
                that.currentUsername = that.username;
                that.setLoading(false);
                that.success = true;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.modal_message = "Congratulations! You have successfully updated your username.";
                that.show_message_modal = true;
                that.enableUsername = true;
                that.showSidebar = true;
                that.username_agree = false;


            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                } else {
                    that.modal_message = error.response.data.message;
                    that.show_otp_modal = false;
                    that.otp = '';
                }
                that.error = true;
                that.info = false;
                that.warning = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.show_otp_modal = false;
                that.otp = '';

            });
        },
        updateTin() {
            const that = this;
            const cookie = that.$cookies;
            let store = that.$store;
            let state = store.state;
            let tin = that.tin.replace('-', '')
            let tin1 = tin.charAt(0) + tin.charAt(1) + tin.charAt(2);
            let tin2 = tin.charAt(3) + tin.charAt(4) + tin.charAt(5);
            let tin3 = tin.charAt(7) + tin.charAt(8) + tin.charAt(9);

            that.setLoading(true);
            that.currentTin = '';
            that.show_message_modal = false;
            let payload = {
                hash: cookie.get('user_session').hash,
                value: tin1 + '-' + tin2 + '-' + tin3,
            }
            User.updateTin(that.$store.state.credentials.key, payload).then(function () {
                that.success = true;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.modal_message = "Congratulations! You have successfully updated your TIN.";
                that.show_message_modal = true;
                that.tin_agree = false;
                that.setLoading(false);
                state.credentials.tin = that.tin;
                that.currentTin = that.tin;
                that.showSidebar = true;

                that.menuItems.forEach(item => {
                    if (item.title === "Member Information") {
                        item.subItems = item.subItems.filter(sub => sub !== "Add TIN");
                    }
                });

                // Open "Edit Username" as active nav
                that.selectedSubItem = "Edit Username";
                // Optionally, open the Account Information section
                that.menuItems.forEach(item => {
                    item.open = item.subItems.includes("Edit Username");
                });

                if (that.currentTin && that.birthdate) {
                    that.menuItems = that.menuItems.filter(item => item.title !== "Member Information");
                }

            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.error = true;
                that.warning = false;
                that.info = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
            });
        },
        updateMobile() {
            const that = this;
            const cookie = that.$cookies;

            // var payload = {
            //     hash: cookie.get('user_session').hash,
            //     value: '+63'+that.mobile_number,
            // }
            that.setLoading(true);
            that.show_message_modal = false;
            User.editMobile(cookie.get('user').uuid, that.edit_payload).then(function () {
                that.show_otp_modal = false;
                that.otp = '';
                that.success = true;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.enableMobile = false;
                that.modal_message = "Congratulations! Your mobile number has been successfully updated.";
                that.show_message_modal = true;
                that.mobile_agree = false;
                that.currentMobile = '+63' + that.mobile_number;
                that.$store.state.credentials.mobile = that.currentMobile;
                that.showSidebar = true;
                that.timerEnabled = false;
                that.timerCount = 120;
                that.setLoading(false);
                if (!that.currentEmail) {
                    that.selectedSubItem = 'Edit Email Address';

                    that.menuItems.forEach(item => {
                        item.open = item.subItems.includes('Edit Email Address');
                    });
                }


            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.setLoading(false);
                    that.error = true;
                    that.$store.state.logged = false;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
            });
        },
        updatePassword() {
            const that = this;
            const cookie = that.$cookies;

            that.setLoading(true);
            that.show_message_modal = false;
            var updatingPasswordPayload = {
                hash: cookie.get('user_session').hash,
                old_password: that.old_password,
                new_password: that.new_password,
                con_password: that.con_password,
            }
            User.changePassword(updatingPasswordPayload, cookie.get('user').uuid).then(function () {
                that.success = true;
                that.warning = false;
                that.info = false;
                that.error = false;
                that.modal_message = "Congratulations! You have successfully updated your password. Please log in again to try.";
                that.show_message_modal = true;
                that.disablePassword = true;
                that.password_changed = true;
                that.password_agree = false;
                that.setLoading(false);

                that.$nextTick(() => {
                    that.$refs.oldPasswordField?.clearText();
                    that.$refs.newPasswordField?.clearText();
                    that.$refs.conPasswordField?.clearText();
                });

                // Clear any bound data (optional but safe)
                that.old_password = '';
                that.new_password = '';
                that.con_password = '';

            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.error = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.show_otp_modal = false;
                that.otp = '';
                that.clearText = ' ';
                that.$nextTick(() => {
                    that.clearText = '';
                });
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.error = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.error = true;
                that.warning = false;
                that.info = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;

            });
        },
        handleOnCompleteEmail() {
            let that = this;
            if (that.otp_payload.type == '6') {
                that.submitOtpEmail();
            }
            else if (that.otp_payload.type == '7') {
                that.submitOtpMobile();
            }
            else if (that.otp_payload.type == '3') {
                that.submitDeactivationOtp();
            }
            else if (that.otp_payload.type == '4') {
                that.submitReactivationOtp();
            }

        },
        togglePeekerUpdatePin(e) {
            if (e == 1) {
                if (this.new_pin_type == 'password') {
                    this.visible_new_pin = true;
                    this.new_pin_type = 'number';
                } else {
                    this.visible_new_pin = false;
                    this.new_pin_type = 'password';
                }
            } if (e == 2) {
                if (this.con_pin_type == 'password') {
                    this.visible_con_pin = true;
                    this.con_pin_type = 'number';
                } else {
                    this.visible_con_pin = false;
                    this.con_pin_type = 'password';
                }
            }
            else {
                if (this.deact_pin_type == 'password') {
                    this.visible_deact_pin = true;
                    this.deact_pin_type = 'number';
                } else {
                    this.visible_deact_pin = false;
                    this.deact_pin_type = 'password';
                }
            }

        },
        togglePeeker() {
            if (this.old_pin_type == 'password') {
                this.visible = true;
                this.old_pin_type = 'number';
            } else {
                this.visible = false;
                this.old_pin_type = 'password';
            }
        },
        updateEmail() {
            let that = this;
            const cookie = that.$cookies;
            User.editEmail(cookie.get('user').uuid, that.edit_payload).then(function () {
                that.timerCount = 120;
                that.show_resend_otp = true;
                that.show_otp_modal = false;
                that.otp = '';
                that.success = true;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.modal_message = "Congratulations! Your email address has been successfully updated.";
                that.show_message_modal = true;
                that.email_agree = false;
                that.currentEmail = that.email;
                that.$store.state.credentials.email = that.currentEmail;
                that.timerEnabled = false;
                that.timerCount = 120;
                that.setLoading(false);
                that.enableEmail = false;
                that.showSidebar = true;

                if (!that.currentMobile) {
                    that.selectedSubItem = 'Edit Mobile Number';

                    that.menuItems.forEach(item => {
                        item.open = item.subItems.includes('Edit Mobile Number');
                    });
                }

            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.error = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.error = true;
                that.warning = false;
                that.info = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
            });
        },
        submitOtpMobile() {
            let that = this;
            that.setLoading(true);
            const cookie = that.$cookies;
            that.otp_payload.otp = that.otp;
            OTP.validate(that.otp_payload).then(function (response) {
                let data = response.data.data
                that.otp_pin = data.otp_pin;
                that.otp_token = data.otp_token;
                that.edit_payload = {
                    value: '+63' + that.mobile_number,
                    otp_token: that.otp_token,
                    otp_pin: that.otp_pin,
                    hash: cookie.get('user_session').hash,
                    update_key: that.otp_payload.update_key
                }
                that.updateMobile();
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.error = true;
                    that.warning = false;
                    that.info = false;
                    that.success = false;
                    that.setLoading(false);
                    that.show_otp_modal = false;
                    that.show_message_modal = true;
                    that.otp = '';
                    that.otpInputKey++;
                    that.modal_message = "Your session has expired. Please log in again.";
                } else {
                    that.setLoading(false);
                    that.otp_error_message = error.response.data.message;
                    that.otp = '';
                    that.otpInputKey++;
                }
            });
        },
        deactivateConfirmedAccount() {
            let that = this;
            const cookie = that.$cookies;
            let store = that.$store;
            let state = store.state;

            let payload = {
                otp_token: that.edit_payload.otp_token,
                otp_pin: that.edit_payload.otp_pin,
                deactivation_key: that.edit_payload.deactivation_key
            }
            that.otp = '';
            that.show_otp_modal = false;
            User.deactivateConfirm(cookie.get('user').uuid, payload).then(function () {
                state.credentials.deactivated = true;
                that.warning = false;
                that.error = false;
                that.success = true;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.deact_logout = true;
                that.modal_message = "You have successfully deactivated your account.";
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.otp = '';
                    that.otpInputKey++;
                    that.show_otp_modal = false;
                }
                that.modal_message = error.response.data.message;
                that.otp = '';
                that.show_otp_modal = false;
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
            });
        },
        submitReactivationOtp() {
            let that = this;
            that.setLoading(true);
            const cookie = that.$cookies;
            that.otp_payload.otp = that.otp;

            OTP.validate(that.otp_payload).then(function (response) {
                let data = response.data.data
                that.otp_pin = data.otp_pin;
                that.otp_token = data.otp_token;
                that.edit_payload = {
                    otp_token: that.otp_token,
                    otp_pin: that.otp_pin,
                    hash: cookie.get('user_session').hash,
                    reactivation_key: that.otp_payload.reactivation_key,
                }
                that.reactivateConfirmedAccount();
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.otp = '';
                    that.show_otp_modal = false;
                } else {
                    that.setLoading(false);
                    that.otp_error_message = error.response.data.message;
                    that.otp = '';
                    that.otpInputKey++;
                }
            });
        },

        reactivateConfirmedAccount() {
            let that = this;
            const cookie = that.$cookies;
            let store = that.$store;
            let state = store.state;
            that.otp = '';
            that.show_otp_modal = false;
            let payload = {
                otp_token: that.edit_payload.otp_token,
                otp_pin: that.edit_payload.otp_pin,
                reactivation_key: that.edit_payload.reactivation_key,
                hash: cookie.get('user_session').hash
            }
            User.reactivateConfirm(cookie.get('user').uuid, payload).then(function () {
                state.credentials.deactivated = null;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.success = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = "You have successfully reactivated your account.";
                that.otp = '';
                that.show_otp_modal = false;
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.otp = '';
                    that.show_otp_modal = false;
                }
                that.otp_error_message = error.response.data.message;
                that.otp = '';
                that.otpInputKey++;
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_otp_modal = false;
                that.show_message_modal = true;
            });
        },
        submitDeactivationOtp() {
            let that = this;
            that.setLoading(true);
            const cookie = that.$cookies;
            that.otp_payload.otp = that.otp;

            OTP.validate(that.otp_payload).then(function (response) {
                let data = response.data.data
                that.otp_pin = data.otp_pin;
                that.otp_token = data.otp_token;
                that.edit_payload = {
                    otp_token: that.otp_token,
                    otp_pin: that.otp_pin,
                    hash: cookie.get('user_session').hash,
                    deactivation_key: that.otp_payload.deactivation_key,
                    password: that.deac
                }
                that.deactivateConfirmedAccount();
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.warning = false;
                    that.info = false;
                    that.success = false;
                    that.setLoading(false);
                    that.show_otp_modal = false;
                    that.show_message_modal = true;
                    that.otp = '';
                    that.modal_message = "Your session has expired. Please log in again.";
                } else {
                    that.setLoading(false);
                    that.otp_error_message = error.response.data.message;
                    that.otp = '';
                    that.otpInputKey++;

                }
            });
        },
        submitOtpEmail() {
            let that = this;
            that.setLoading(true);
            const cookie = that.$cookies;
            that.otp_payload.otp = that.otp;
            OTP.validate(that.otp_payload).then(function (response) {
                let data = response.data.data
                that.otp_pin = data.otp_pin;
                that.otp_token = data.otp_token;
                that.edit_payload = {
                    value: that.email,
                    otp_token: that.otp_token,
                    otp_pin: that.otp_pin,
                    hash: cookie.get('user_session').hash,
                    update_key: that.otp_payload.update_key
                }
                that.updateEmail();
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.warning = false;
                    that.$store.state.logged = false;
                    that.success = false;
                    that.info = false;
                    that.setLoading(false);
                    that.show_otp_modal = false;
                    that.show_message_modal = true;
                    that.otp = '';
                    that.otpInputKey++;
                    that.modal_message = "Your session has expired. Please log in again.";

                } else {
                    that.setLoading(false);
                    that.otp_error_message = error.response.data.message;
                    that.otp = '';
                    that.otpInputKey++;
                }
            });
        },
        getImgSrc() {
            return this.visible ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        getImgSrcNewPin() {
            return this.visible_new_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        getImgSrcConPin() {
            return this.visible_con_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        getImgSrcDeactPin() {
            return this.visible_deact_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        handleLogout() {
            const store = this.$store;
            const cookie = this.$cookies;
            const payload = {
                hash: store.state.credentials.hash
            };
            this.loading = true;
            User.logout(payload)
                .then(() => {

                    store.state.logged = false;
                    store.state.credentials.hash = '';
                    cookie.remove('user');
                    cookie.remove('user_session');
                    this.$router.push('/');
                    this.loading = false;
                    this.show_message_modal = false;
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        this.expired = true;
                        this.setLoading(false);
                        this.$store.state.logged = false;
                        this.error = true;
                        this.info = false;
                        this.warning = false;
                        this.success = false;
                        this.show_message_modal = true;
                        this.modal_message = "Your session has expired. Please log in again.";
                    }
                    store.state.logged = false;
                    store.state.credentials.hash = '';
                    this.$emit('donelogout');
                    this.$router.push('/');
                    this.loading = false;
                    this.show_message_modal = false;
                    this.show_otp_modal = false;
                    this.otp = '';
                });
        },
        deactivateAccount() {
            const that = this;
            const cookie = that.$cookies;
            let store = that.$store;
            let state = store.state;

            var validationPayload = {
                hash: cookie.get('user_session').hash,
                password: that.deac
            }
            that.setLoading(true);
            that.show_message_modal = false;
            that.show_pin_modal = false;
            that.show_otp_modal = false;
            that.deact_pin_value = '';
            that.otpInputKey++;
            that.pin_error_message = '';
            User.deactivate(cookie.get('user').uuid, validationPayload).then(function (response) {
                let data = response.data.data
                that.setLoading(false);

                if (that.email == '' || that.email == null) {
                    that.email = state.credentials.email;
                }
                if (that.mobile_number == '' || that.mobile_number == null) {
                    that.mobile_number = state.credentials.mobile;
                }
                that.otp_payload = {
                    deactivation_key: data.hash,
                    pin: data.pin,
                    email: that.currentEmail,
                    type: '3',
                    mobile: '+63' + that.currentMobile
                };
                that.show_pin_modal = true;
                that.deactivation_pin = data.pin;


            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                    that.otpInputKey++;
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.otpInputKey++;
                that.error = true;
                that.warning = false;
                that.success = false;
                that.info = false;
                that.setLoading(false);
                that.show_message_modal = true;
                that.show_otp_modal = false;
                that.otp = '';
                that.otpInputKey++;
            });
        },
        triggerDeactivate() {
            const that = this;
            const cookie = that.$cookies;

            that.setLoading(true);
            User.deactivate(cookie.get('user').uuid).then(function () {
                that.success = true;
                that.warning = false;
                that.error = false;
                that.info = false;
                that.show_message_modal = true;
                that.show_otp_modal = false;
                that.setLoading(false);
                that.otp = '';
                that.otpInputKey++;
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                    that.otp = '';
                    that.otpInputKey++;
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.otp = '';
                that.otpInputKey++;
                that.error = true;
                that.info = false;
                that.warning = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
            });
        },
        showUpdateMobileView() {
            if (this.showUpdateMobile == false) {
                this.showUpdateMobile = true;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showUpdatePasswordView() {
            if (this.showPasswordUpdateView == false) {
                this.showPasswordUpdateView = true;
                this.showUpdateMobile = false;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showUpdateTinView() {
            if (this.showUpdateTin == false) {
                this.showUpdateTin = true;
                this.showPasswordUpdateView = false;
                this.showUpdateMobile = false;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showSecurityView = false;
            }
        },
        showSecurity() {
            if (this.showSecurityView == false) {
                this.showUpdateMobile = false;
                this.showUpdateUsername = false;
                this.showUpdateEmail = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = true;
                this.showUpdateTin = false;
            }
        },
        showAccountView() {
            if (this.showAccountInfoView == false) {
                this.showPasswordUpdateView = false;
                this.showAccountInfoView = true;
                this.showSecurityView = false;
                this.showPasswordUpdateView = false;
                this.showSecurityView = false;
                this.showUpdateTin = false;
            }
        },
        showMenu() {
            if (this.show_menu) {
                this.hideMenu();
            } else {
                this.show_menu = true;
            }
        },
        hideMenu() {
            this.show_menu = false;
        },
        changed(e) {
            let key = e.key;
            let that = this;
            that[key] = e.value;
            if (key == 'mobile_number') {
                that.checkChange({ value: e.value, type: 1 });
            }
            if (key == 'email') {
                that.checkChange({ value: e.value, type: 2 });
            }
            if (key == 'username') {
                that.checkChange({ value: e.value, type: 3 });
            }
            if (key === 'tin') {
                const tinDigits = e.value.replace(/-/g, '');
                this.enableTIN = tinDigits.length === 9 && /^\d{3}-\d{3}-\d{3}$/.test(e.value);
            }
            if (key === 'date' && e.value) {
                const [year, month, day] = e.value.split('-');
                that.year = year;
                that.month = month;
                that.day = day;
                // Enable the Add button only if all are present and valid
                that.enableDate = !!(year && month && day);
            }
            if (
                this.old_password &&
                this.new_password &&
                this.con_password &&
                this.new_password === this.con_password &&
                this.score === 'Strong'
            ) {
                this.disablePassword = false;
            } else {
                this.disablePassword = true;
            }
            if (this.deac && this.deac.trim() !== '') {
                this.enableDeact = false;
            } else {
                this.enableDeact = true;
            }
        },
        checkChange(e) {
            if (e.type == 1) {
                const isDifferent = e.value !== this.currentMobile;
                const isValidMobile = /^9\d{9}$/.test(e.value);

                this.enableMobile = isDifferent && isValidMobile;
            }
            if (e.type == 2) {
                const isDifferent = e.value !== this.currentEmail;
                const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.value);

                this.enableEmail = isDifferent && isValidEmail;
            }
            if (e.type == 3) {
                const isSame = e.value === this.currentUsername;
                const isValidLength = e.value.length >= 6;
                const hasNoSpaces = !/\s/.test(e.value);
                const isAlphanumeric = /^[a-zA-Z0-9]+$/.test(e.value);

                if (isSame || !isValidLength || !hasNoSpaces || !isAlphanumeric) {
                    this.enableUsername = true;
                } else {
                    this.enableUsername = false;
                }
            }
        },
        handleNegativeClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.closed_modal();
            }
        },
        otpUpdate(e) {
            let that = this;
            that.otp = e.value;
        },
        downloadQR() {
            let url = this.getQr();
            axios.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'image/png' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'QR';
                    link.click();
                    URL.revokeObjectURL(link.href);
                })
        },
        resendOtp() {
            let that = this;
            let store = that.$store;
            let state = store.state;
            // that.setLoading(true);
            that.show_resend_otp = false;
            that.timerEnabled = true;
            that.timerCount = 120;
            // console.log('OTP PAYLOAD', that.otp_payload);
            that.otp_payload.name = state.credentials.name;
            OTP.requestOtp(that.otp_payload).then(function () {
                that.setLoading(false);
            }).catch(function (error) {
                if (error.response.status == 403) {
                    that.expired = true;
                    that.error = true;
                    that.$store.state.logged = false;
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.show_otp_modal = false;
                }
                that.modal_message = error.response.data.message;
                that.show_otp_modal = false;
                that.error = true;
                that.show_otp_modal = false;
                that.warning = false;
                that.info = false;
                that.success = false;
                that.setLoading(false);
                that.show_message_modal = true;
            });
        },
        getQr() {
            let that = this;
            const cookie = that.$cookies;
            return "https://quickchart.io/qr?text=" + cookie.get('user').hash;
        },
        closed() {
            let that = this;

            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        proceedToConfirm() {
            if (!/^\d{6}$/.test(this.enroll_pin)) {
                this.pin_error = 'PIN must be exactly 6 digits.';
                return;
            }

            const easyPins = ['123456', '000000', '111111', '654321'];
            if (easyPins.includes(this.enroll_pin)) {
                this.pin_error = 'PIN is too weak';
                this.enroll_btn = false;
                this.enroll_pin = '';
                this.otpInputKey++;
                return;
            }

            this.pin_error = '';
            this.confirmMode = true;
        },

        goBackToInitial() {
            this.confirm_pin = '';
            this.confirmMode = false;
            this.pin_error = '';
        },
        changeEnrollPIN() {
            this.pin_error = '';
            this.enroll_btn = false;
            this.enable_next = false;
        },
        changeEnrollConPIN() {
            this.pin_error = '';
            this.enroll_con_btn = false;
        },
        proceedToConfirmUpdate() {
            if (!/^\d{6}$/.test(this.update_pin)) {
                this.update_pin_error = 'PIN must be exactly 6 digits.';
                return;
            }

            const easyPins = ['123456', '000000', '111111', '654321'];
            if (easyPins.includes(this.update_pin)) {
                this.update_pin_error = 'PIN is too weak.';
                this.change_update_pin = false;
                this.update_pin = '';
                this.otpInputKey++;
                return;
            }
            this.update_pin_error = '';
            this.confirmUpdateMode = true;
        },
        goBackToUpdatePinInput() {
            this.confirmUpdateMode = false;
            this.confirm_update_pin = '';
            this.update_pin_error = '';
        },
        submitUpdatedPin() {
            const cookie = this.$cookies;

            if (this.update_pin !== this.confirm_update_pin) {
                this.update_pin_error = "PINs do not match.";
                this.error_pin = true;
                this.change_update_con_pin = false;
                this.confirm_update_pin = '';
                this.otpInputKey++;
                return;
            }

            const pin_payload = {
                hash: cookie.get('user_session').hash,
                value: this.confirm_update_pin,
                pin: this.old_pin,
            };

            this.loading = true;
            this.error_pin = false;

            User.updatePin(cookie.get('user').uuid, pin_payload)
                .then(() => {
                    this.show_new_pin = false;
                    this.loading = false;
                    this.success = true;
                    this.warning = false;
                    this.error = false;
                    this.modal_message = "Congratulations! You have successfully updated your PIN.";
                    this.show_message_modal = true;
                    this.change_pin_btn = false;
                    this.timerEnabled = false;
                    this.timerCount = 120;
                    this.update_pin = '';
                    this.confirm_update_pin = '';
                    this.otpInputKey++;
                    this.old_pin = '';
                    this.pin_agree = false;
                    this.$store.state.credentials.pin_update = false;
                    this.showSidebar = true;

                    if (this.$store.state.credentials.edit_temporary) {
                        const state = this.$store.state;
                        const config = state.credentials.config;
                        state.credentials.has_pin = true;
                        state.credentials.enrolled_pin = true;
                        state.credentials.pin_update = false;

                        if (!config || !config.status) {
                            this.$cookies.set('validated', true);
                            this.$router.push('/dashboard');
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        this.expired = true;
                        this.setLoading(false);
                        this.$store.state.logged = false;
                        this.error = true;
                        this.info = false;
                        this.warning = false;
                        this.success = false;
                        this.show_message_modal = true;
                        this.modal_message = "Your session has expired. Please log in again.";
                    }
                    this.error = true;
                    this.warning = false;
                    this.success = false;
                    this.loading = false;
                    this.show_message_modal = true;
                    this.modal_message = error.response.data.message;
                    this.change_pin_btn = false;
                    this.show_otp_modal = false;
                    this.show_new_pin = false;
                    this.otp = '';
                    this.otpInputKey++;
                    this.update_pin = '';
                    this.confirm_update_pin = '';
                    this.otpInputKey++;
                    this.old_pin = '';
                });
        }

    },
    watch: {
        authValue(newVal, oldVal) {
            if (this.skipAuthWatcher) return;
            this.enable3FA();
        },
        new_password(val) {
            this.$nextTick(() => {
                const confirmField = this.$refs.conPasswordField;
                if (confirmField && confirmField.validateField) {
                    confirmField.validateField(this.con_password);
                }
            });
        },
        con_password(val) {
            this.$nextTick(() => {
                const confirmField = this.$refs.conPasswordField;
                if (confirmField && confirmField.validateField) {
                    confirmField.validateField(val);
                }
            });
        },
        tin(val) {
            const tinDigits = val.replace(/-/g, '');
            this.enableTIN = tinDigits.length === 9 && /^\d{3}-\d{3}-\d{3}$/.test(val);
        },
        timerCount: {
            handler(value) {
                let that = this;
                //  console.log(value,that.timerEnabled);
                if (value > 0 && that.timerEnabled) {
                    that.show_resend_otp = false;
                    setTimeout(() => {
                        that.timerCount = that.timerCount - 1;
                        // console.log(this.timerCount);
                    }, 1000);
                } else {
                    that.show_resend_otp = true;
                    that.timerEnabled = false; // run your function here
                }
            },
            immediate: true
        },
        '$store.state.credentials': {
            handler(newVal) {
                if (newVal.username && (newVal.has_pin !== undefined)) {
                    this.checkUserFlow();
                }
            },
            deep: true
        },
        // '$store.state.clickedEdit'(val) {
        //     if (val === 'mobile') {
        //     this.selectedSubItem = 'Edit Mobile Number';
        //     this.menuItems.forEach(item => {
        //         item.open = item.subItems.includes('Edit Mobile Number');
        //     });
        //     } else if (val === 'email') {
        //     this.selectedSubItem = 'Edit Email Address';
        //     this.menuItems.forEach(item => {
        //         item.open = item.subItems.includes('Edit Email Address');
        //     });
        //     } else {
        //     this.selectedSubItem = 'Edit Username';
        //     this.menuItems.forEach(item => {
        //         item.open = item.subItems.includes('Edit Username');
        //     });
        //     }
        // }
    }
})
</script>
<style>
.max-width-back {
    max-width: 50px;
}

.shadowed {
    text-shadow: 0.10em 1.5px black;
}

input::placeholder {
    flex: 1;
    font-size: 18px;
    text-align: center;
    font-weight: 800;
}
</style>
